import SlackLinkPage from '@gokrew/ui/components/SlackLinkPage';
import { TeamsLogo } from '@gokrew/ui/components/TeamsLogo';
import { TranslationNS } from '@gokrew/models/constants';
import { getUserInitials } from '@gokrew/ui/utility/utility';
import { linkTeamsAccount } from '@/api/teams-link';
import { useEmployeePortalAuth } from '@/context/EmployeeAuthContext';
import { companyDisplayName } from '@gokrew/ui/utility/companyDisplayName';

/** Distinct from the Slack key so the two link flows cannot clobber each other. */
const TEAMS_TOKEN_KEY = 'teams_link_token';

export default function EmployeeTeamsLinkPage() {
  const { user } = useEmployeePortalAuth();

  const userInitials = user
    ? getUserInitials({
        firstName: user.user.firstName,
        lastName: user.user.lastName,
      })
    : null;

  return (
    <SlackLinkPage
      onLink={linkTeamsAccount}
      dashboardPath="/dashboard"
      i18nPrefix="teamsLink"
      namespace={TranslationNS.teams}
      tokenKey={TEAMS_TOKEN_KEY}
      teamsPopupAware
      confirmFirst
      logo={<TeamsLogo size={45} />}
      companyName={companyDisplayName(user?.company) || null}
      companyLogoUrl={user?.company?.logo ?? null}
      userAvatarUrl={user?.user?.profileImage ?? null}
      userInitials={userInitials}
    />
  );
}
